import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PublicPagesModule } from './modules/public-pages.module';
import { LearnerCertificateStatusComponent } from './page-components/certificate-status/certificate-status.component';
//import { PreventionCmsComponent } from './page-components/prevention-cms/prevention-cms.component';
import { RegistrationRedirectComponent } from './page-components/registration-redirect/registration-redirect.component';
import { LocalizationGuard } from './translation/guard/localization.guard';
import { ScrollGuard } from './translation/guard/scroll.guard';
import { AccountErrorComponent } from './components/account-error/account-error.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'safety-and-prevention/home' },
  //{ path: 'prevention-cms', component: PreventionCmsComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: 'MLITSDPreventionCMS.Title' } },
  //{ path: 'fr/prevention-cms', component: PreventionCmsComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: 'MLITSDPreventionCMS.Title' } },

  { path: 'learner/certificate-status/:programCode/:workerId', component: LearnerCertificateStatusComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: 'MLITSDPreventionCMS.Title' } },
  { path: 'fr/learner/certificate-status/:programCode/:workerId', component: LearnerCertificateStatusComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: 'MLITSDPreventionCMS.Title' } },

  { path: 'registration/:regtype', component: RegistrationRedirectComponent, canActivate: [LocalizationGuard, ScrollGuard] },
  { path: 'fr/registration/:regtype', component: RegistrationRedirectComponent, canActivate: [LocalizationGuard, ScrollGuard] },

  { path: 'safety-and-prevention', loadChildren: () => PublicPagesModule },
  { path: 'fr/safety-and-prevention', loadChildren: () => PublicPagesModule },
  { path: 'training-provider', loadChildren: async () => (await import('./modules/training-provider.module')).TrainingProviderModule },
  { path: 'fr/training-provider', loadChildren: async () => (await import('./modules/training-provider.module')).TrainingProviderModule },
  { path: 'worker', loadChildren: async () => (await import('./modules/worker.module')).WorkerModule },
  { path: 'fr/worker', loadChildren: async () => (await import('./modules/worker.module')).WorkerModule },
  // This was done when learner portal was down due to privacy issues. Keeping for reference
  // { path: 'worker', component: NotFoundWorkerComponent, data: { title: 'General.PageNotFound' } },
  // { path: 'fr/worker', component: NotFoundWorkerComponent, data: { title: 'General.PageNotFound' } },

  { path: 'employer', loadChildren: async () => (await import('./modules/employer.module')).EmployerModule },
  { path: 'fr/employer', loadChildren: async () => (await import('./modules/employer.module')).EmployerModule },

  { path: 'marketplace', loadChildren: async () => (await import('./modules/marketplace.module')).MarketplaceModule },
  { path: 'fr/marketplace', loadChildren: async () => (await import('./modules/marketplace.module')).MarketplaceModule },

  { path: 'account-error', component: AccountErrorComponent, data: { title: 'General.PageNotFound' } },
  { path: 'not-found', component: NotFoundComponent, data: { title: 'General.PageNotFound' } },
  { path: '**', redirectTo: '/not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [provideZoneChangeDetection()],
  exports: [RouterModule]
})
export class AppRoutingModule { }

